import { useRef } from 'react';

import Analytics, { ElementShownAnchor } from '@hh.ru/analytics-js';
import { Tag, TooltipHover } from '@hh.ru/magritte-ui';
import { PhoneOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { ElementSpyInstance } from 'bloko/common/elementSpy';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { useVacancyId } from 'src/components/ResumeCard/hooks/useVacancyId';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

export interface AnalyticsParams {
    resumeHash: string;
    employerId?: string;
    employerManagerId?: string;
    vacancyId?: number;
    searchSessionId?: string;
    searchRid?: string;
}

const sendEventElementShown = (element: HTMLElement, analyticsParams: AnalyticsParams): ElementSpyInstance =>
    Analytics.sendHHEventElementShown(element, {
        elementName: 'resume_card_applicant_liveness_tag',
        ...analyticsParams,
    });

const TrlKeys = {
    tag: 'resume.card.tag.applicantLiveness',
    dropInfo: 'resume.card.tag.applicantLiveness.dropInfo',
};

export interface ApplicantLivenessProps {
    resumeHash: string;
    searchRid?: string;
}

const ApplicantLiveness: TranslatedComponent<ApplicantLivenessProps> = ({ resumeHash, searchRid, trls }) => {
    const activatorRef = useRef<HTMLSpanElement>(null);

    const employerId = useSelector((state) => state.employerId) || undefined;
    const employerManagerId = useSelector((state) => state.employerManager?.id);
    const searchSessionId = useSelector((state) => state.searchSessionId) || undefined;
    const vacancyId = useVacancyId();

    return (
        <>
            <ElementShownAnchor
                fn={sendEventElementShown}
                resumeHash={resumeHash}
                employerId={employerId}
                employerManagerId={employerManagerId}
                vacancyId={vacancyId}
                searchSessionId={searchSessionId}
                searchRid={searchRid}
            >
                <span ref={activatorRef}>
                    <Tag icon={PhoneOutlinedSize16} style="positive">
                        {trls[TrlKeys.tag]}
                    </Tag>
                </span>
            </ElementShownAnchor>
            <TooltipHover placement="top-center" activatorRef={activatorRef}>
                {trls[TrlKeys.dropInfo]}
            </TooltipHover>
        </>
    );
};

export default translation(ApplicantLiveness);
